/* eslint-disable no-param-reassign */
import { Store } from '@wonderlandlabs/looking-glass-engine';
import _ from 'lodash';
import { message } from 'antd';

import QueryModel from '../../store/models/Category/QueryModel';
import {
  categoryFetchQuery, categoryAddRecord, categoryFetchRecord, Category,
} from '../../store/models/Category';

import {
  eventToNumber, eventToBoolean, eventToString,
  eventToObject,
}
  from '../../utils/eventExtraction';

const SEMVER = /^([\d+])\.([\d+])\.([\d+])(.*)/;
export default ({ loadCategories, activateObjDialog }) => {
  const queryStore = new Store({
    state: {},
    start: ({ state }) => ({ ...state, queryModel: new QueryModel() }),
    actions: {
      resetProps: ({ state, _propsState }) => {
        const newState = { ...state };

        const propValues = { ..._propsState };
        Object.keys(propValues).forEach((propName) => {
          if (Array.isArray(propValues[propName])) {
            propValues[propName] = [];
          }
        });

        Object.assign(newState, propValues, {
          queryTabs: new Map(),
          queryModel: new QueryModel(''),
        });
        return newState;
      },
      setQueryPart(store, part, value) {
        const { actions, state } = store;
        const model = state.queryModel;
        model[part] = value;

        actions.updateModel();
      },
      toggleEditQuery(store) {
        const { editingQuery } = store.state;
        store.actions.setEditingQuery(!editingQuery);
      },
      updateModel(store) {
        const { actions, state } = store;
        const model = state.queryModel;
        try {
          model.compose();
        } catch (err) {
          console.log('composing error', err);
        }
        actions.setQueryModel(model.clone());
        actions.setComposing(false);
      },
      async saveToCategory({ state, actions }) {
        const { queryName, queryModel, token } = state;
        const categoryName = queryName;

        if (!categoryName) {
          message.error('Please choose a name for your category', 2);
          return;
        }
        if (!token) {
          message.error('We have no token - please re-log in', 2);
          return;
        }
        const { query } = queryModel;
        if (!query) {
          message.error('cannot save a Category with an empty query', 2);
          return;
        }
        const toSave = {
          categoryName,
          query,
          version: '1.0.0',
        };
        let oldCategory;
        try {
          oldCategory = await categoryFetchRecord(categoryName, token);
          if (oldCategory) {
            let { version } = oldCategory;
            if (SEMVER.test(version)) {
              const [maj, minor, thirdThing] = SEMVER.exec(version);
              version = [maj, minor, parseInt(thirdThing, 10) + 1].join('.');
            } else {
              version = '1.0.0';
            }
            Object.assign(toSave, oldCategory, { query, version });
          }
        } catch (err) { // is a new category - not a true error.

        }
        try {
          const result = await categoryAddRecord(toSave, token);
          console.log('result of saving category: ', result);
          message.info(oldCategory ? `updated Category "${categoryName}"` : `saved Category "${categoryName}"`, 2);
        } catch (err) {
          message.error(`cannot save Category "${categoryName}": ${err.message}`, 2);
        }
      },
      async addSelectField(store) {
        const { state, actions } = store;
        const { selectField } = state;
        const model = state.queryModel;
        if (!model) {
          return;
        }
        console.log('adding select field', selectField, 'to', model.query, '(', model.id, ')');
        await model.addSelectField(selectField);
        actions.updateModel();
      },
      addOrderField(store, desc = false) {
        const { actions, state } = store;
        const model = state.queryModel;
        const { orderField } = store.state;
        console.log('adding order field --- ', orderField);
        model.addOrderField(orderField, desc);
        actions.updateModel();
      },
      addOrderFieldDesc({ actions }, field) {
        actions.addOrderField(true);
      },
      addOrderFieldAsc({ actions }, field) {
        actions.addOrderField(false);
      },
      chooseQueryName({ state, actions }, event) {
        actions.setQueryName(eventToString(event));
      },
      chooseQuery({ state, actions }, query = '') {
        const queryModel = new QueryModel(eventToString(query));
        return { ...state, page: 0, queryModel };
      },
      chooseQuerySelect({ state, actions }, value) {
        actions.setQueryPart('select', eventToString(value));
      },
      chooseTab(store, tabKey = 'query') {
        store.actions.setTabKey(tabKey);
      },
      schemaMenuClick({ state, actions }, item, target, advanced = false, desc = false) {
        console.log('schema menu click', item, target, advanced);
        if (advanced) {
          actions.setPendingField(item);
          actions.setPendingFieldTarget(target);
          actions.setShowPendingFieldDialog(true);
          return;
        }
        const { queryModel } = state;
        queryModel.addField(item, target, false, null, desc);
        actions.updateModel();
      },
      confirmPendingFieldDialog(store, save, value, comp) {
        const { pendingField, pendingFieldTarget, queryModel } = store.state;
        store.actions.setPendingField(false);
        store.actions.setPendingFieldTarget(false);
        store.actions.setShowPendingFieldDialog(false);
        if (!save) {
          return;
        }
        console.log('confirm: adding ', pendingField, pendingFieldTarget, value, comp);
        queryModel.addField(pendingField, pendingFieldTarget, value, comp);
        store.actions.updateModel();
      },
      async saveQuategory({ actions, state }, categoryRecord) {
        if (categoryRecord === false) { // cancelled dialog
          actions.setShowSaveDialog(false);
        } else if (categoryRecord) { // save action from dialog
          try {
            await categoryAddRecord(categoryRecord, state.token);
            loadCategories();
            message.success(`saved ${categoryRecord.categoryName}`);
          } catch (err) {
            console.log('---- saveQuategory error in category save: ', err);
            await new Promise((done) => {
              message.danger(`did not save category: ${err.message}`, 3, done);
            });
          }
          actions.setShowSaveDialog(false);
        } else { // open dialog
          actions.setShowSaveDialog(true);
        }
      },
      chooseQueryFrom({ actions }, value) {
        actions.setQueryPart('from', eventToString(value));
      },
      chooseQueryWhere({ actions }, value) {
        actions.setQueryPart('where', eventToString(value));
      },
      addWhereField({ actions, state }, value) {
        const { queryModel } = state;
        queryModel.addWhereField(eventToString(value));
        actions.updateModel();
      },
      chooseQueryOrderBy({ actions }, value) {
        actions.setQueryPart('order', eventToString(value));
      },
      chooseQueryOffset({ actions }, value) {
        actions.setQueryPart('offset', eventToNumber(value));
      },
      chooseQueryLimit({ actions }, value) {
        actions.setQueryPart('limit', eventToNumber(value));
      },
      chooseQueryBeforeDate({ actions }, value) {
        const date = eventToObject(value);
        console.log('chooseQueryBeforeDate:date', date, 'from', value);
        actions.setQueryPart('beforeDate', date);
      },
      chooseQueryAfterDate({ actions }, value) {
        actions.setQueryPart('afterDate', eventToObject(value));
      },
      toggleUseBeforeDate({ actions }, value) {
        const use = eventToBoolean(value);
        actions.setQueryPart('useBeforeDate', !use);
      },
      toggleUseAfterDate({ actions }, value) {
        actions.setQueryPart('useAfterDate', !eventToBoolean(value));
      },
      chooseOrderField(state, event) {
        state.actions.setOrderField(eventToString(event));
      },
      chooseSelectField({ actions }, event) {
        console.log('choosing select field: ', event, 'value', eventToString(event));
        actions.setSelectField(eventToString(event));
      },

      chooseActiveField({ state, actions }, activeField) {
        actions.setActiveField(state.activeField === activeField ? '' : activeField);
      },
      updateTab({ actions, state }, name, params) {
        const oldTab = state.queryTabs.get(name);
        if (!oldTab) {
          return;
        }
        Object.extend(oldTab, params);
        actions.cloneQueryTabs();
      },
      insertTab({ actions, state }, name, params) {
        state.queryTabs.set(name, params);
        actions.cloneQueryTabs();
      },
      toggleCollapse({ actions }, event) {
        console.log('toggling collapse');
        const toggleValue = eventToBoolean(event);
        console.log('toggle collapse value: ', toggleValue, event);
        actions.setCollapse(!toggleValue);
      },
    },
  });

  queryStore
    .addProp('computedUrl', {
      type: 'string',
      start:
        '',
    })
    .addProp('showSaveDialog', {
      type: 'boolean',
      start: false,
    })
    .addProp('pendingField', {
      type: 'object',
    })
    .addProp('pendingFieldTarget', {
      type: 'string',
    })
    .addProp('showPendingFieldDialog', {
      type: 'boolean',
      start: false,
    })
    .addProp('selectField', {
      type: 'string',
      start: '',
    })
    .addProp('currentMediaItem', {
      start: false,
    })
    .addProp('queryModel', {
      start: new QueryModel(''),
      type: 'object',
    })
    .addProp('editingTarget', {
      type: 'string',
      start: '',
    })
    .addProp('tabKey', {
      start: 'query',
      type: 'string',
    })
    .addProp('token', {
      start: '',
      type: 'string',
    })
    .addProp('totalResults', {
      start: 0,
      type: 'integer',
    })
    .addProp('queryName', {
      type: 'string',
      start: '',
    })
    .addProp('queryTabs', {
      start: new Map(),
    })
    .addProp('mediaLoaded', {
      type: 'boolean',
      start: false,
    })
    .addProp('editingQuery', {
      type: 'boolean',
      start: true,
    })
    .addProp('uploading', {
      type: 'boolean',
      start: false,
    })
    .addProp('collapse', {
      type: 'boolean',
      start: false,
    })
    .addProp('composing', {
      type: 'boolean',
      start: false,
    })
    .addProp('orderField', {
      start: '',
      type: 'string',
    })
    .addProp('chosenSelectField', {
      start: '',
      type: 'string',
    })
    .addProp('activeField', {
      start: '',
      type: 'string',
    });

  queryStore.debugStream = {
    next(data) {
      return;
      console.log(
        '--debug queryTabStore for TAB ', data.state.queryName, ': change: ',
        _.get(data, 'change.info.action'),
        'resolved', _.get(data, 'change._resolved'),
        'id', _.get(data, 'change.id'),
        'data:', data,
      );
    },
  };
  queryStore.start();
  console.log('query store made: ', queryStore);
  return queryStore;
};
